import React, { useState } from "react";
import { NuUpload } from "../../../../Components/Utils/Input";
import axiosInstance from "../../../../Services/axiosCommon";
import { useToast } from "../../../../Components/Others/ToastServices";
import { CancelButton, SubmitButton } from "../../../../Components/Utils/Buttons";

const ImportModal = ({ show, onClose, onSuccess }) => {
  const toast = useToast();
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      toast.open({
        type: "warning",
        message: "Please select a file to import",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    setIsLoading(true);
    try {
      const res = await axiosInstance.post("/ageing-analysis/import", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data) {
        setFile(null);
        onClose();
        if (onSuccess) onSuccess();
        toast.open({
          type: "success",
          message: "Imported File Added successfully",
        });
      } else {
        toast.open({
          type: "error",
          message: "Imported File Added failed",
        });
      }
    } catch (err) {
      toast.open({
        type: "error",
        message:
          err.response?.data?.message ||
          err.response?.data?.msg ||
          "Imported File Added failed",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length) {
      setFile(e.target.files[0]);
    }
  };

  if (!show) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center p-3 sm:p-4">
      <div className="animate-scale-in w-full sm:w-[480px] max-w-[95vw] max-h-[90vh] bg-white py-4 px-4 sm:px-6 rounded-xl shadow-lg overflow-y-auto">
        <h2 className="text-lg font-bold text-gray-800 mb-4">
          Import Ageing Analysis
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="w-full mb-4">
            <NuUpload
              label="Attachment"
              width="w-full"
              accept=".xlsx, .xls, .csv"
              onChange={handleFileChange}
            />
          </div>
          <div className="flex justify-end gap-2 pt-2 border-t border-gray-100">
            <CancelButton handleClick={onClose} />
            <SubmitButton name="Import" isLoading={isLoading} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default ImportModal;
